module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/cms/cms.component.html
// module id = ./src/app/routes/cms/cms.component.html
// module chunks = 9